import * as actions_notifications from 'actions/notifications-actions';
import * as actions_service_requests from 'actions/service-requests-actions';
import * as actions_users from 'actions/users-actions';
import * as toolbox from 'components/common/toolbox';
import React from 'react';
import moment from 'moment';
import { APPS } from 'components/constants';
import { Timestamp } from "firebase/firestore";
import { navMultipleUrls } from 'components/common/toolbox';
import { numPanels } from 'components/common/toolbox';
import { useParams, useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useSelector, useDispatch } from 'react-redux';

/**
 * NotificationItem component. 
 * Used to show each notification from an array of notification objects.
 * 
 * @param { Object } props - Component props
 * @param { string } props.id - Firestore document ID of notification
 * @param { string } props.subject - Notification subject (similar to a title)
 * @param { string } props.message - Message of the notification
 * @param { Timestamp } props.date - Date the notification was sent / created
 * @param { entity } props.entity - The entity being notified about.
 * @param { entityId } props.entityId - The ID of the entity being notified about.
 * @param { boolean } props.lastIndex - Determines if item is the last index of the notification list
 * @param { boolean } props.shouldClick - If false, disables the onClick functionality.
 * @param { boolean } props.read - Determines if the document has been read or not
 * 
 * @example
 * <NotificationItem subject={"Boss"} message={"My Message"} date={new Date()} lastIndex={false} />
 * 
 * @returns { JSX.Element }
 */
export default function NotificationItem({
    id,
    subject,
    message,
    date,
    entity,
    entityId,
    read,
    hideModalCallback,
    lastIndex,
}) {
    const dispatch = useDispatch()
    const params = useParams()
    const history = useHistory()

    const user = useSelector((store) => store.users.user);
    
    const momentDate = moment(date.toDate()); // Converts Firestore Timestamp to moment object
    const timeAgo =  momentDate.fromNow(); // Ex: 3 days ago
    const calendarTimeOfNotification = momentDate.calendar(); // Ex: Yesterday at 6:54pm
    const dateOfNotification = momentDate.format('MM.DD.YYYY'); // Ex: 12.11.2024
    const notificationDateString = `${calendarTimeOfNotification} - ${dateOfNotification}`;

    const viewDetails = async () => {
        if (typeof hideModalCallback === "function") hideModalCallback();

        dispatch(actions_notifications.viewDetails({
            entity, 
            entityId, 
            actions_service_requests,
            // Standard params
            actions_users, 
            dispatch, 
            history, 
            numPanels, 
            params, 
            user,
        }));
    }

    var entityName = '';

    switch(entity) {
        case 'service-request':
            entityName = 'Service Request';
            break;
        default:
            break;
    }

    return (
        
        <div className="dropdown-messages-box" onClick={!read ? () => {
            dispatch(actions_notifications.markNotificationAsRead(params.handle, id));
            if (typeof hideModalCallback === "function") hideModalCallback();
        } : null}>
            <div className="notification-item text-left p-2">
                <small className="float-right text-muted">{ timeAgo }</small>
                <strong>{ subject }</strong> <br />
                <p className="mb-0">{ message }</p>
                <div><small className="mt-1 text-muted">{ notificationDateString }</small></div>
                { entityId && <button className="btn btn-primary btn-sm mt-2" onClick={viewDetails}>{ `View ${entityName}` }</button>}
            </div>
            { !lastIndex ? <div className="dropdown-divider" /> : null }
        </div>
    )
}